import { Injectable } from '@angular/core';
import type { ConnectorConfig, ConnectorOption } from '../models/batch.interface';

@Injectable({
  providedIn: 'root'
})
export class ConnectorConfigService {
  private readonly connectorConfigs: { [key: string]: ConnectorConfig } = {
    HK_TRADE: {
      connector: 'HK_TRADE',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Uploaded on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    },
    AG_DESK: {
      connector: 'AG_DESK',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Uploaded on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    },
    GNM: {
      connector: 'GNM',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Uploaded on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    },
    FEES_MGMT: {
      connector: 'FEES_MGMT',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Uploaded on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    },
    HK_LC: {
      connector: 'HK_LC',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Uploaded on', visible: true, type: 'date', format: 'dd/MM/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'dd/MM/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    }
    ,
    PFEU: {
      connector: 'PFEU',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'documentType', header: 'Document Type', visible: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Captured on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'uploadedBy', header: 'Uploaded by', visible: true },
        // { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    },
    PFNA: {
      connector: 'PFNA',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'documentType', header: 'Document Type', visible: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Captured on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        // { field: 'noOfPages', header: 'No of pages', visible: true, sortable: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    },
    VCF: {
      connector: 'VCF',
      columns: [
        { field: 'queueId', header: 'Queue ID', visible: true, sortable: true },
        { field: 'batchName', header: 'Batch name', visible: true, sortable: true },
        { field: 'complianceStatus',header: 'Document Compliance',visible: true, type: 'metadata', metadataField: 'Compliance Status', sortable: true },
        { field: 'documentType', header: 'Document Type', visible: true },
        { field: 'status', header: 'Status', visible: true, type: 'status', sortable: true },
        { field: 'datetime', header: 'Captured on', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'connector', header: 'Connector', visible: false },
        { field: 'lastModifiedDate', header: 'Last updated', visible: true, type: 'date', format: 'MM/dd/yyyy HH:mm', sortable: true },
        { field: 'operator', header: 'Updated by', visible: true },
        { field: 'noOfPages', header: 'No of pages', visible: false, sortable: true },
        { field: 'uploadedBy', header: 'Uploaded by', visible: true }
      ],
      defaultSort: { field: 'queueId', order: 'desc' }
    }
  };

  readonly CONNECTOR_OPTIONS: ConnectorOption[] = [
    // Expose available connectors. Added PFEU and PFNA (Project Finance) alongside AG_DESK
    { value: 'AG_DESK', viewValue: 'Agency Desk' },
    { value: 'PFEU', viewValue: 'Project Finance' },
    { value: 'VCF', viewValue: 'Value Chain Finance' },
    // { value: 'PFNA', viewValue: 'Project Finance - NA' }
  ];

  public getConnectorConfig(connector: string): ConnectorConfig | undefined {
    return this.connectorConfigs[connector];
  }

  public getConnectorOptions(): ConnectorOption[] {
    return this.CONNECTOR_OPTIONS;
  }

  // Helper method to get visible columns for a connector
  public getVisibleColumns(connector: string): string[] {
    const config = this.getConnectorConfig(connector);
    return config?.columns.filter(col => col.visible).map(col => col.field) || [];
  }
}